import { render, staticRenderFns } from "./DetailRedeem.vue?vue&type=template&id=4c78c4b5"
import script from "./DetailRedeem.vue?vue&type=script&lang=js"
export * from "./DetailRedeem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports